import * as types from './action-types'

function handleErrors(res) {
  if (!res.ok) throw Error(res.statusText)
  return res
}

const requestArtists = () => ({
  type: types.REQUEST_ARTISTS
})

const receiveArtists = data => ({
  type: types.RECEIVE_ARTISTS,
  payload: {
    data,
    receivedAt: Date.now()
  }
})

const errorArtists = () => ({
  type: types.ERROR_ARTISTS
})

export const fetchArtists = () => dispatch => {
  dispatch(requestArtists());

  return fetch(`/api/artists`)
    .then(handleErrors)
    .then(res => res.json())
    .then(json => dispatch(receiveArtists(json)))
    .catch(e => dispatch(errorArtists(e)))
}

export const setArtistsEnabled = enabled => ({
  type: types.SET_ARTISTS_ENABLED,
  payload: enabled
})



// WEBPACK FOOTER //
// ./src/components/artist-list-container/actions.js